// AUTO-GENERATED by scripts/codegen.py — DO NOT EDIT BY HAND.
// Source of truth: protocol/src/protocol/models.py + auth/user_role.py. Regenerate: pnpm codegen.


export const TaskStatus = {
  PENDING: "pending",
  RUNNING: "running",
  COMPLETED: "completed",
  MERGING: "merging",
  MERGED: "merged",
  CONFLICT: "conflict",
  FAILED: "failed",
  CANCELLED: "cancelled",
} as const;
export type TaskStatus = (typeof TaskStatus)[keyof typeof TaskStatus];

/** Statuses that mean the task has reached a terminal lifecycle state. */
export const TERMINAL_TASK_STATUSES: ReadonlySet<TaskStatus> = new Set([
  TaskStatus.COMPLETED,
  TaskStatus.MERGING,
  TaskStatus.MERGED,
  TaskStatus.CONFLICT,
  TaskStatus.FAILED,
  TaskStatus.CANCELLED,
]);

export const SessionStatus = {
  ACTIVE: "active",
  IDLE: "idle",
  CLOSED: "closed",
} as const;
export type SessionStatus = (typeof SessionStatus)[keyof typeof SessionStatus];

export const UserRole = {
  MEMBER: "member",
  PLATFORM_ADMIN: "platform_admin",
} as const;
export type UserRole = (typeof UserRole)[keyof typeof UserRole];
